import { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Notification } from '../../types';

/**
 * Service for notification-related API calls
 */
export const notificationService = {
  /**
   * Register a device token for push notifications
   * @param token - The device token
   */
  registerToken: (token: string): Promise<AxiosResponse> => {
    return apiClient.post('/api/tokens', { token, type: 'firebase' });
  },

  /**
   * Get notifications
   * @param interval - Optional time interval filter
   */
  getNotifications: (interval?: string): Promise<AxiosResponse<Notification[]>> => {
    return apiClient.get('/api/notifications', { params: { interval } });
  },

  /**
   * Perform an action on a notification
   * @param notificationId - The notification ID
   * @param action - The action to perform (e.g., 'read', 'dismiss')
   * @param data - Optional data to send with the action
   */
  performNotificationAction: (
    notificationId: string,
    action: string,
    data?: any,
  ): Promise<AxiosResponse> => {
    return apiClient.post(`/api/notifications/${notificationId}/${action}`, data);
  },

  /**
   * Perform a bulk action on multiple notifications
   * @param action - The action to perform (e.g., 'read-all', 'dismiss-all')
   * @param ids - Array of notification IDs
   * @param domain - Optional domain to prefix IDs
   */
  performBulkNotificationAction: (
    action: string,
    ids: string[],
    domain?: string,
  ): Promise<AxiosResponse> => {
    const formattedIds = domain ? ids.map((id) => `${domain}-${id}`) : ids;
    return apiClient.post(`/api/notifications/${action}`, formattedIds);
  },
};
